import { tableV2BodyRowHeightPx } from '@/features/shared/components/tableSystem/TableV2Constants';

export const tableV2RenderedDividerHeightPx = 0.5;

export const resolveTableV2BodyRowHeight = (hasRenderedDivider: boolean): string => {
  const rowHeight =
    tableV2BodyRowHeightPx +
    tableV2RenderedDividerHeightPx +
    (hasRenderedDivider ? tableV2RenderedDividerHeightPx : 0);
  return `${String(rowHeight)}px`;
};

export const resolveTableV2BodyRowsHeight = (rowCount: number): string => {
  const bodyHeight =
    rowCount * tableV2BodyRowHeightPx + Math.max(0, rowCount - 1) * tableV2RenderedDividerHeightPx;
  return `${String(bodyHeight)}px`;
};
